import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { client } from 'graphql/client';
import { listRoutes } from 'graphql/queries';
import { z } from 'zod';

import { errorHandler } from './errors';

import type { Route } from 'API';
import { RouteSchema } from 'APIzod';

export const routesApi = createApi({
    reducerPath: 'routes',
    baseQuery: graphqlRequestBaseQuery({
        url: '/graphql',
    }),
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        listRoutes: builder.query<Route[], string>({
            queryFn: async () => {
                try {
                    const { data } = await client.graphql({ query: listRoutes });
                    return { data: z.array(RouteSchema()).parse(data.listRoutes) };
                } catch (error) {
                    throw errorHandler('Unexpected error occurred while fetching the routes', error);
                }
            },
        }),
    }),
});

export const { useLazyListRoutesQuery, useListRoutesQuery } = routesApi;
